module.exports = __webpack_public_path__ + "static/media/comments-icon.c7d13e8b.svg";